import styled from 'styled-components'
import TableContainer from '@material-ui/core/TableContainer'
import Paper from '@material-ui/core/Paper'
import TableCell from '@material-ui/core/TableCell'

export const PageContainer = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  padding: 40px 32px 80px;
`

export const PageTitle = styled.h1`
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  color: #111;
  margin-bottom: 48px;
  letter-spacing: -0.01em;
`

export const Section = styled.div`
  margin-bottom: 56px;
`

export const SectionTitle = styled.h2`
  font-size: 17px;
  font-weight: 600;
  color: #111;
  margin-bottom: 2px;
`

export const SectionSubtitle = styled.p`
  font-size: 13px;
  color: #666;
  margin-bottom: 20px;
`

export const OverviewTableContainer = styled(TableContainer).attrs({ component: Paper })`
  overflow-x: auto;
  border-radius: 8px;
  scrollbar-width: thin;
  scrollbar-color: #d0d0d0 transparent;

  &::-webkit-scrollbar {
    height: 4px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #d0d0d0;
    border-radius: 2px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #aaa;
  }
`

export const HeaderCell = styled(TableCell)`
  padding: 6px 16px !important;
  text-align: right !important;
  font-weight: 600 !important;
  color: #333 !important;
  background: #fafafa !important;
  white-space: nowrap !important;
`

export const FirstHeaderCell = styled(TableCell)`
  padding: 6px 16px !important;
  text-align: left !important;
  font-weight: 600 !important;
  color: #333 !important;
  background: #fafafa !important;
  min-width: 220px !important;
`

export const BodyCell = styled(TableCell)`
  padding: 6px 16px !important;
  text-align: right !important;
  color: #222 !important;
  white-space: nowrap !important;
`

export const FirstBodyCell = styled(TableCell)`
  padding: 6px 16px !important;
  text-align: left !important;
  font-weight: 500 !important;
  color: #111 !important;
  white-space: nowrap !important;
`

export const RowLabel = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;
`

export const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  color: #fff;
  background: ${({ positive }) => (positive ? '#1a73e8' : '#d32f2f')};
`

export const CheckboxReadOnly = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 15px;
  height: 15px;
  border: 1.5px solid #aaa;
  border-radius: 2px;
  background: ${({ checked }) => (checked ? '#e8e8e8' : '#fff')};
  border-color: ${({ checked }) => (checked ? '#888' : '#aaa')};
`

export const CheckboxCell = styled.div`
  display: flex;
  justify-content: flex-end;
`
